import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { HelperWrapper, TextInput } from 'src/components'

import useStyles from '../styles'

interface IProps {
  ownerEmail: string
}

export const OwnerEmailInput = ({ ownerEmail }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.ownerWrapper}>
      <TextInput
        fullWidth
        disabled
        value={ownerEmail}
        inputUpperLabel={t('account-form-owner-email-input-label.v')}
      />
      <div className={classes.changeOwnerWrapper}>
        <Button component={Link} to={{ search: '?tab=users' }} className={classes.changeOwnerLink}>
          <HelperWrapper t="account-form-owner-email-button-text" />
        </Button>
      </div>
    </div>
  )
}
